import { render, staticRenderFns } from "./resourceField.vue?vue&type=template&id=2d282b17&scoped=true&"
import script from "./resourceField.vue?vue&type=script&lang=js&"
export * from "./resourceField.vue?vue&type=script&lang=js&"
import style0 from "./resourceField.vue?vue&type=style&index=0&id=2d282b17&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d282b17",
  null
  
)

export default component.exports